import React from'react';
import OwlCarousel from 'react-owl-carousel2';
import PropTypes from 'prop-types';
import apiSettings from '../../../../config/api';
import appConst from '../../../../config/const';


const createSrcPath = (img, size) => {
  let src = '/assets/img/noimage.png';
  if (img && img.preview) {
    src = img.preview;
  }
  if (img && img[appConst.PHOTOS[size]] && img.updatedAt) {
    src = apiSettings.endpoints.genImageUrl(img[appConst.PHOTOS[size]], img.updatedAt);
  }
  return src;
};

const owlOptions = {
  items: 4,
  nav: true,
  dots: false,
  rewind: true,
  autoplay: true,
  autoplayHoverPause: true,
  margin: 20,
  responsive: {
    320: {
      items: 1
    },
    400: {
      items: 2
    },
    660: {
      items: 3
    },
    980: {
      items: 4
    }
  }
};

class PreviewImagesBlock extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      currentImage: 0
    }
  }

  static propTypes = {
    images: PropTypes.array,
  };

  changeImage(currentImage){
    this.setState({currentImage})
  }

  render() {

    const {
      images
    } = this.props;

    const {
      currentImage
    } = this.state;

    if (images && images.length > 0)
      return (
        <div className="tour-page__photos">
          <div className="tour-page__photos-main">
            <img
              src={createSrcPath(images[currentImage], 'medium')}
              alt="Preview"
            />
          </div>
          <div className="tour-page__photos-other">
            <OwlCarousel key="owl-1" options={owlOptions}>
              {
                images.map((photo, index) => {
                  return (
                    <div
                      className="create-tour__photos-item"
                      key={`create-preview-img-block-${photo.id}`}
                      onClick={() => {this.changeImage(index)}}
                      role="presentation"
                      onKeyDown={() => {
                      }}
                    >
                      <img
                        src={createSrcPath(photo, 'small')}
                        alt="text"
                      />
                    </div>
                  )
                })
              }
            </OwlCarousel>
          </div>
        </div>
      );
    return (
      <div>
        <h3>No Images</h3>
      </div>
    )
  }
}

export default PreviewImagesBlock;


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Templates/PreviewImagesBlock.js